const timeline = [
	{
		title: "Last Date For Registration through Online",
		time: "20.04.2024",
		
	},
	{
		title: "Intimation Date",
		time: "22.04.2024",
	},
	{
		title: "Event Date",
		time: "24.04.2024",
	},
	{
		title: "Registration Starts",
		time: "24.04.2024 9:00 AM",
	},
	{	title: "Prayer Song",
	time: "24.04.2024 9:30 AM",
	},
	{
		title: "Welcome Address ",
		time: "24.04.2024 9:35 AM",
	},
	{
		title: "Lighting the Kuthuvilaku",
		time: "24.04.2024 9:40 AM",
	},
	{
		title: "Felicitation Address by Dr.G.Kavitha HoD/CSE",
		time: "24.04.2024 9:45 AM",
	},
	{
		title: "Presidential Address by Dr.M.Madheswaran Principal/MEC",
		time: "24.04.2024 9:55 AM",
	},
	{
		title: "Introduction and Honoring of Chief Guest ",
		time: "24.04.2024 10:05 AM",
	},
	{
		title: "Chief Guest Address",
		time: "24.04.2024 10:10 AM",
	},
	{
		title: "Refreshment",
		time: "24.04.2024 10:30 AM",
	},
	{
		title: "Commencement of Events ",
		time: "24.04.2024 10:45 AM to 1:00 PM",
	},
	{
		title: "Lunch",
		time: "24.04.2024 1:00 PM",
	},
	{
		title: "Velidictory Function",
		time: "24.04.2024 1:45 PM",
	},
	{
		title: "Culturals",
		time: "24.04.2024 2:00-to 5:00 PM",
	},
];
export default timeline;
